/**
 * Compare record variable based on it's existence
 */
export enum RecordComparison {
  isBlank = 1,
  isPresent = 2,
}